import MDReactComponent from 'markdown-react-js';

import './hero-date.scss';

export default ({ date }) => {
  return (
    <div className='Hero-date'>
      <span className='Hero-date__copy'>
        <MDReactComponent text={date} />
      </span>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/atoms/HeroDate/index.js